import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import { App } from "./App";
import { restoreAppearance } from "./lib/prefs";
import { blockNativeDrag } from "./lib/noNativeDrag";

// Paint with this device's last appearance until the account's preferences load.
restoreAppearance();
blockNativeDrag();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
